// src/pages/NotFound.jsx
import { Button, Container, Heading, Text } from "@chakra-ui/react";

export default function NotFound() {
  return (
    <Container maxW="lg" py={20}>
      <Heading mb={3}>Page not found</Heading>
      <Text mb={6}>The link may be broken or the page moved.</Text>
      <Button as="a" href="/">Go to homepage</Button>
    </Container>
  );
}
